import React, { memo } from 'react'
import { Slide } from '@mui/material'
import { styled } from '@mui/system'
import { colorPalette } from '../../style/colorPalette'
import { Button } from '../buttons'

type Props = {
  /** タイトル（例：「未保存の項目があります」） */
  title: string
  /** ボタンに表示する文言 */
  buttonLabel: string
  /** ボタンクリック時の動作 */
  onButtonClick: () => void
  /** 開閉状態 */
  open: boolean
  /** ボタンラベルの右に表示するサブテキスト（例：ショートカットキー） */
  buttonSubLabel?: string
}

const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
  padding: '8px 12px 8px 24px',
  backgroundColor: colorPalette.green[0],
  border: `1px solid ${colorPalette.green[6]}`,
  borderLeft: 'none',
  borderRadius: '0 4px 4px 0',
  boxShadow: '0px 4px 16px 0px rgba(123, 140, 170, 0.5)',
})

const Title = styled('p')({
  margin: 0,
  fontSize: 12,
  fontWeight: 700,
  lineHeight: 1.5,
  color: colorPalette.green[7],
})

const ButtonLabel = styled('span')({
  fontSize: 12,
  fontWeight: 500,
  color: colorPalette.monotone[0],
})

const ButtonSubLabel = styled('span')({
  fontSize: 10,
  fontWeight: 700,
  color: colorPalette.green[2],
})

export const HeaderAction: React.FC<Props> = memo(
  ({ title, buttonLabel, onButtonClick, open, buttonSubLabel }) => {
    return (
      <Slide
        style={{
          top: 4,
          position: 'fixed',
        }}
        direction="right"
        in={open}
        timeout={500}
      >
        <Container>
          <Title>{title}</Title>
          <Button onClick={onButtonClick} colorPattern="green" size="s">
            <ButtonLabel>{buttonLabel}</ButtonLabel>
            {buttonSubLabel && (
              <ButtonSubLabel>{buttonSubLabel}</ButtonSubLabel>
            )}
          </Button>
        </Container>
      </Slide>
    )
  }
)

HeaderAction.displayName = 'HeaderAction'

export default HeaderAction
